// extracted by mini-css-extract-plugin
module.exports = {"container":"faq_container__R0LZz","heading":"faq_heading__3mt8j","subheading":"faq_subheading__MmL9C","accordionContainer":"faq_accordionContainer__w_9RB"};